const customCarousels = document.getElementsByName('custom-tours-testimonials');
if (customCarousels.length) {
    customCarousels.forEach((carousel) => {
        const getCarouselHeight = () => {
            if (window.innerWidth < 768) return '360px';
            return '600px';
        };

        document.addEventListener('DOMContentLoaded', function () {
            import('@splidejs/splide').then((Splide) => {
                new Splide.default(carousel, {
                    type: 'loop',
                    autoplay: 'play',
                    height: getCarouselHeight(),
                    pagination: false,
                    perPage: 1,
                    perMove: 1,
                    gap: '0px',
                    padding: { right: 16 },
                    arrows: false,
                }).mount();
            });
        });
    });
}
